import React from "react";
import { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import DocumentContract from "../components/Contract/DocumentContract";
import DocumentRecibo from "components/Contract/DocumentRecibo";
import { NumeroALetras } from "../functions/formatoletras";

const useDocumentContract = () => {
  const [contrato] = useState({
    introduccion: {
      titulo: "CONTRATO DE PROMESA DE USUFRUCTO CON RESERVA DE DOMINIO",
      descripcion: [
        "QUE CELEBRAN POR UNA PARTE COMO CEDENTE (Y A QUIEN EN LO SUCESIVO ASÍ SE LE DENOMINARA) EL C ",
        "CON DOMICILIO EN ",
        "Y QUE SE IDENTIFICA CON CREDENCIAL PARA VOTAR CON FOTOGRAFÍA NÚMERO ",
        "Y POR LA OTRA PARTE COMO CESIONARIO (YA QUIEN EN LO SUCESIVO ASÍ SE LE DENOMINARA) ",
        " EL (LA) C. ",
        ", CON DOMICILIO EN ",
        " CON NUMERO DE TELEFONO ",
        " Y QUE SE IDENTIFICA CON CLAVE DE ELECTOR ",
        " QUIENES SE SUJETAN AL TENOR DE LAS SIGUIENTES DECLARACIONES Y CLAUSULAS. "
      ]
    },
    declaraciones: {
      titulo: "DECLARACIONES",
      descripcion: [
        "I.-DECLARA EL C. ALFREDO CORONA RUIZ, SER PROPIETARIO DEL " +
          "DESARROLLO RUSTICO RANCHO ALEGRE CUAL CONSTA EN EL CERTIFICADO NO. 000001034798," +
          "DE FECHA DEL 22 (VEINTIDÓS), DE MAYO DE 2017 (DOS MIL DIECISIETE)" +
          "DEBIDAMENTE INSCRITA EN EL REGISTRO AGRARIO," +
          "DE LA PARCELA NO. 26 Z-1 P1/9 PROPIEDAD QUE HA FRACCIONADO EN LOTES RÚSTICOS," +
          "SIENDO SU INTENCIÓN CEDERLOS," +
          "MANIFESTANDO TENER PLENA CAPACIDAD JURÍDICA PARA HACERLO UBICADA EN EL EJIDO SANTA MONICA," +
          "MUNICIPIO DE EPAZOYUCAN, ESTADO DE HIDALGO",
        "II.- DECLARA EL CESIONARIO, TENER PLENA CAPACIDAD JURÍDICA, PARA CELEBRAR TANTO ESTE " +
          "CONTRATO A TÍTULO ONEROSO, COMO EL DEFINITIVO, SUJETÁNDOSE AL TENOR DE LAS SIGUIENTES"
      ]
    },
    clausulas: [
      {
        titulo: "PRIMERA",
        descripcion:
          "DECLARA EL C. ALFREDO CORONA RUIZ, SER PROPIETARIO DEL " +
          "DESARROLLO RUSTICO RANCHO ALEGRE CUAL CONSTA EN EL CERTIFICADO NO. 000001034798," +
          "DE FECHA DEL 22 (VEINTIDÓS), DE MAYO DE 2017 (DOS MIL DIECISIETE)" +
          "DEBIDAMENTE INSCRITA EN EL REGISTRO AGRARIO," +
          "DE LA PARCELA NO. 26 Z-1 P1/9 PROPIEDAD QUE HA FRACCIONADO EN LOTES RÚSTICOS," +
          "SIENDO SU INTENCIÓN CEDERLOS," +
          "MANIFESTANDO TENER PLENA CAPACIDAD JURÍDICA PARA HACERLO UBICADA EN EL EJIDO SANTA MONICA," +
          "MUNICIPIO DE EPAZOYUCAN, ESTADO DE HIDALGO"
      },
      {
        titulo: "SEGUNDA",
        descripcion:
          "SEGUNDA. - AMBOS CONTRATANTES ACUERDAN QUE SE LIQUIDARÁ DE CONTADO EN LA FECHA EN QUE SE FIRME EL PRESENTE INSTRUMENTO Y UNA VEZ QUE NO EXISTA ADEUDO ALGUNO POR PARTE DEL CESIONARIO, CONTRATO DEFINITIVO A TÍTULO ONEROSO, RESPECTO DEL LOTE SEÑALADO CON EL NUMERO 14 MANZANA XVII UBICADO EN EL LUGAR DENOMINADO 'DESARROLLO RUSTICO RANCHO ALEGRE' PERTENECIENTE AL MUNICIPIO EPAZOYUCAN, HIDALGO; SIENDO ESTO ANTE LA PRESENCIA DE TESTIGOS, ASÍ COMO DAR CUMPLIMIENTO A LO ESTIPULADO."
      },
      {
        titulo: "TERCERA",
        descripcion:
          "TERCERA.-TANTO EL CEDENTE COMO EL CESIONARIO, SE OBLIGAN A CEDER Y ADQUIRIR RESPECTIVAMENTE PARA SI O PARA LA PERSONA FÍSICA O MORAL QUE PARA EL EFECTO QUE DESIGNE, EL LOTE RÚSTICO, CITADO EN EL PÁRRAFO QUE ANTECEDE; MISMO QUE CUENTA CON LAS SIGUIENTES MEDIDAS Y COLINDANCIAS: "
      }
    ]
  });

  const [datosCedentes] = useState({
    nombrecedente: "ALFREDO CORONA RUIZ",
    domiciliocedente:
      "CALLE ADOLFO RUIZ CORTINES, NÚMERO 6, COLONIA CENTRO, SANTA MONICA, EPAZOYUCAN, HIDALGO, C.P. 43590 ",
    credencialcedente: "0368021943789 "
  });

  const generateinfoClient = (infoclientes, infodireccioncliente) => {
    let datoscliente = {
      nombrecliente:
        infoclientes.NOMBRES.toUpperCase() +
        " " +
        infoclientes.APELLIDO_PATERNO.toUpperCase() +
        " " +
        infoclientes.APELLIDO_MATERNO.toUpperCase(),
      domiciliocliente: infodireccioncliente[0].DIRECCION.toUpperCase(),
      numerotelefonico: infoclientes.TELEFONO_FIJO,
      credencialcliente: infoclientes.CLAVE_ELECTOR
    };
    return datoscliente;
  };

  const generateinfoLot = infolotes => {
    const filterlots = Object.values([infolotes]);

  /*  const totalCosto = filterlots.reduce((acc, lote) => {
      return acc + lote.COSTO;
    }, 0);

    const totalSuperficie = filterlots.reduce((acc, lote) => {
      return acc + lote.SUPERFICIE;
    }, 0);

    const numeroslotes = filterlots.reduce((acc, lote, index) => {
      if (!acc.includes(lote.NUMERO)) {
        acc.push(lote.NUMERO);
      }
      if (index !== filterlots.length - 1) {
        acc[acc.length - 1] += ", ";
      }
      return acc;
    }, []);

    const numerosmanzana = filterlots.reduce((acc, lote, index) => {
      if (!acc.includes(lote.CODIGO)) {
        acc.push(lote.CODIGO);
      }
      if (index !== filterlots.length - 1) {
        acc[acc.length - 1] += ", ";
      }
      return acc;
    }, []);
*/
    let datoslote = {
      lotes: filterlots, //filterlots.filter(lote => typeof lote === "object"),
      TOTALCOSTO: infolotes.COSTO,
      COSTOLETRA: NumeroALetras(infolotes.COSTO),
      totalSuperficie: infolotes.SUPERFICIE,
      NUMEROSLOTES: infolotes.NUMERO,
      NUMEROSMANZANA: infolotes.CODIGO
    };
    return datoslote;
  };

  const generateinfocontrato = (infocontrato, infolotes) => {
    //let filterlots = infolotes;

    /*const totalCosto = filterlots.reduce((acc, lote) => {
      return acc + lote.COSTO;
    }, 0);*/

    let pago = infocontrato.costo;
    let restante = infolotes.COSTO - infocontrato.enganche;
    if (infocontrato.mensualidades > 0)
      pago = (
        (infolotes.COSTO - infocontrato.enganche) /
        infocontrato.mensualidades
      ).toFixed(2);

    let datoscontrato = {
      ...infocontrato,
      engancheletras: NumeroALetras(infocontrato.enganche),
      restante,
      restanteletras: NumeroALetras(restante),
      pagosletras: NumeroALetras(pago),
      pagos: pago
    };

    return datoscontrato;
  };

  const generateReciboPdf = async infoContract => {
    const Contract = () => <DocumentRecibo infoContract={infoContract} />;
    const pdfBlob = await pdf(<Contract />).toBlob();
    const pdfUrl = URL.createObjectURL(pdfBlob);
    return pdfUrl;
  };
  const generatePdf = async (
    infocontrato,
    infoclientes,
    infolotes,
    infodireccioncliente
  ) => {
    const Contract = () => (
      <DocumentContract
        values={contrato}
        datoscedentes={datosCedentes}
        datoscliente={generateinfoClient(infoclientes, infodireccioncliente)}
        datoslote={generateinfoLot(infolotes)}
        datoscontrato={generateinfocontrato(infocontrato, infolotes)}
      />
    );
    const pdfBlob = await pdf(<Contract />).toBlob();
    const pdfUrl = URL.createObjectURL(pdfBlob);
    return pdfUrl;
  };

  return {
    generatePdf,
    generateReciboPdf
  };
};

export default useDocumentContract;
